<template>
  <div class="d-flex flex-row align-center ga-1">
    <v-progress-circular
      v-if="showLoadingIndicator && loadingRealtimePrices"
      indeterminate
      size="24"
      color="primary"
      width="2"
    />
    <span
      ref="price"
      class="text-h5"
      :class="[{ 'text-grey': loadingRealtimePrices }, { 'text-primary': !loadingRealtimePrices }]"
    >
      {{ formatMoney(price, true) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { Money } from '@/generatedTypes'
import { formatMoney } from '@/modules/product/helpers'
import { PropType } from 'vue'

defineProps({
  price: {
    type: Object as PropType<Money>,
    required: true
  },
  showLoadingIndicator: {
    type: Boolean,
    default: false
  },
  loadingRealtimePrices: {
    type: Boolean,
    default: false
  }
})
</script>
